// components.application.rewards.achievementCard.moreInfoModal

export const MORE_INFO_MODAL = {
  titles: {
    objectives: 'Objectives',
    benchmark: 'Benchmark',
    progress: 'Progress'
  }
};
